// Which part of the graphic this embed draws: 'house' (overview, Why it matters and
// the House bar), 'states' (state cards), 'districts' (targeted district cards)
// or 'all' (the full draft page, for testing).
export default 'states';
